export const LABEL_STATUS_NONE = 0
export const LABEL_STATUS_INCLUDED = 1;
export const LABEL_STATUS_EXCLUDED = 2

export const getNextLabelStatus = (curStatus) => {
    return (curStatus + 1) % 3;
}